module.exports = __webpack_public_path__ + "img/monitor.a9e1e27d.png";